export default "__VITE_ASSET__rFVpj1wY__"